import React from "react";
import { useStateManager } from "bcms-react";
import { FormRowView } from "components/shared";
import CountriesCustomSelect from "components/custom-ui/CountriesCustomSelect";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import StatesCustomSelect from "components/custom-ui/StatesCustomSelect";
import { UITextInput } from "components/ui";

/**
 * @function FinancialInstitutionForm
 * @returns {React.Component}
 * @description Shared financial institution form component that is used in the DomesticDetailsFormView and the InternationalDetailsFormView components for the PayeeDetailsPage.
 */
export default function FinancialInstitutionForm(props) {
  const { data, onChange } = useStateManager();
  const payee = data.payee ?? {};
  const formType = props.formType ?? "payeeFinancialInstitution";

  return (
    <>
      { formType === "payeeFinancialInstitution" &&
        <div className="financial-institution-form">
        <FormRowView text="* Institution Number Type">
          <CustomSelect value={ payee.financialInstitutionNumberType } onChange={ onChange("financialInstitutionNumberType") }>
            <CustomSelectItem value="aba">ABA</CustomSelectItem>
          </CustomSelect>
        </FormRowView>
        <FormRowView text="* Institution Name">
            <UITextInput value={ payee.financialInstitutionName } onChange={ onChange("financialInstitutionName") } />
        </FormRowView>
        <FormRowView text="* Institution Number">
            <UITextInput value={ payee.financialInstitutionNumber } onChange={ onChange("financialInstitutionNumber") } />
        </FormRowView>
        <FormRowView text="Address Line 1">
            <UITextInput value={ payee.financialInstitutionAddressLine1 } onChange={ onChange("financialInstitutionAddressLine1") } />
        </FormRowView>
        <FormRowView text="Address Line 2">
            <UITextInput value={ payee.financialInstitutionAddressLine2 } onChange={ onChange("financialInstitutionAddressLine2") } />
        </FormRowView>
        <FormRowView text="City">
            <UITextInput value={ payee.financialInstitutionCity } onChange={ onChange("financialInstitutionCity") } />
        </FormRowView>
        { payee.payeeType === "domestic" &&
        <>
          <FormRowView text="State">
            <StatesCustomSelect value={ payee.financialInstitutionState } onChange={ onChange("financialInstitutionState") }/>
          </FormRowView>
          <FormRowView text="ZIP Code">
              <UITextInput value={ payee.financialInstitutionZip } onChange={ onChange("financialInstitutionZip") } />
          </FormRowView>
        </>
        }
        { payee.payeeType === "international" &&
        <>
          <FormRowView text="State or Province">
            <UITextInput value={ payee.financialInstitutionStateOrProvidence } onChange={ onChange("financialInstitutionStateOrProvidence") }/>
          </FormRowView>
          <FormRowView text="Postal Code">
              <UITextInput value={ payee.financialInstitutionPostalCode } onChange={ onChange("financialInstitutionPostalCode") }/>
          </FormRowView>
          <FormRowView text="* Country">
          <CountriesCustomSelect value={ payee.financialInstitutionCountry } onChange={ onChange("financialInstitutionCountry") }/>
        </FormRowView>
        </>
        }
      </div>
    }
    { formType === "receivingFinancialInstitution" &&
        <div className="financial-institution-form">
        <FormRowView text="* Institution Number Type">
          <CustomSelect value={ payee.receivingInstitutionNumberType } onChange={ onChange("receivingInstitutionNumberType") }>
            <CustomSelectItem value="aba">ABA</CustomSelectItem>
          </CustomSelect>
        </FormRowView>
        <FormRowView text="* Institution Name">
            <UITextInput value={ payee.receivingInstitutionName } onChange={ onChange("receivingInstitutionName") } />
        </FormRowView>
        <FormRowView text="* Institution Number">
            <UITextInput value={ payee.receivingInstitutionNumber } onChange={ onChange("receivingInstitutionNumber") }/>
        </FormRowView>
        <FormRowView text="Address Line 1">
            <UITextInput value={ payee.receivingInstitutionAddressLine1 } onChange={ onChange("receivingInstitutionAddressLine1") } />
        </FormRowView>
        <FormRowView text="Address Line 2">
            <UITextInput value={ payee.receivingInstitutionAddressLine2 } onChange={ onChange("receivingInstitutionAddressLine2") }/>
        </FormRowView>
        <FormRowView text="City">
            <UITextInput value={ payee.receivingInstitutionCity } onChange={ onChange("receivingInstitutionCity") }/>
        </FormRowView>
        { payee.payeeType === "domestic" &&
        <>
          <FormRowView text="State">
            <StatesCustomSelect value={ payee.receivingInstitutionState } onChange={ onChange("receivingInstitutionState") }/>
          </FormRowView>
          <FormRowView text="ZIP Code">
              <UITextInput value={ payee.receivingInstitutionZip } onChange={ onChange("receivingInstitutionZip") } />
          </FormRowView>
        </>
        }
        { payee.payeeType === "international" &&
        <>
          <FormRowView text="State or Province">
            <UITextInput value={ payee.receivingInstitutionStateOrProvidence } onChange={ onChange("receivingInstitutionStateOrProvidence") }/>
          </FormRowView>
          <FormRowView text="Postal Code">
              <UITextInput value={ payee.receivingInstitutionPostalCode } onChange={ onChange("receivingInstitutionPostalCode") }/>
          </FormRowView>
          <FormRowView text="* Country">
          <CountriesCustomSelect value={ payee.receivingInstitutionCountry } onChange={ onChange("receivingInstitutionCountry") }/>
        </FormRowView>
        </>
        }
      </div>
    }
    { formType === "intermediaryFinancialInstitution" &&
        <div className="financial-institution-form">
        <FormRowView text="* Institution Number Type">
          <CustomSelect value={ payee.intermediaryInstitutionNumberType }>
            <CustomSelectItem value="aba">ABA</CustomSelectItem>
          </CustomSelect>
        </FormRowView>
        <FormRowView text="* Institution Name">
            <UITextInput value={ payee.intermediaryInstitutionName } onChange={ onChange("intermediaryInstitutionName") }/>
        </FormRowView>
        <FormRowView text="* Institution Number">
            <UITextInput value={ payee.intermediaryInstitutionNumber } onChange={ onChange("intermediaryInstitutionNumber") }/>
        </FormRowView>
        <FormRowView text="Address Line 1">
            <UITextInput value={ payee.intermediaryInstitutionAddressLine1 } onChange={ onChange("intermediaryInstitutionAddressLine1") }/>
        </FormRowView>
        <FormRowView text="Address Line 2">
            <UITextInput value={ payee.intermediaryInstitutionAddressLine2 } onChange={ onChange("intermediaryInstitutionAddressLine2") }/>
        </FormRowView>
        <FormRowView text="City">
            <UITextInput value={ payee.intermediaryInstitutionCity } onChange={ onChange("intermediaryInstitutionCity") }/>
        </FormRowView>
        { payee.payeeType === "domestic" &&
        <>
          <FormRowView text="State">
            <StatesCustomSelect value={ payee.intermediaryInstitutionState } onChange={ onChange("intermediaryInstitutionState") }/>
          </FormRowView>
          <FormRowView text="ZIP Code">
              <UITextInput value={ payee.intermediaryInstitutionZip } onChange={ onChange("intermediaryInstitutionZip") } />
          </FormRowView>
        </>
        }
        { payee.payeeType === "international" &&
        <>
          <FormRowView text="State or Province">
            <UITextInput value={ payee.intermediaryInstitutionStateOrProvidence } onChange={ onChange("intermediaryInstitutionStateOrProvidence") }/>
          </FormRowView>
          <FormRowView text="Postal Code">
              <UITextInput value={ payee.intermediaryInstitutionPostalCode } onChange={ onChange("intermediaryInstitutionPostalCode") }/>
          </FormRowView>
          <FormRowView text="* Country">
            <CountriesCustomSelect value={ payee.intermediaryInstitutionCountry } onChange={ onChange("intermediaryInstitutionCountry") }/>
          </FormRowView>
        </>
        }
      </div>
    }
  </>
  )

}